import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface Context {
  files: File[]
  updateFiles: (files: File[]) => void
  isUpload: boolean
  updateUpload: (isUpload: boolean) => void
  isUploadError: any
  updateUploadError: (isUploadError: any) => void
  data: any[]
  updateData: (data: any[]) => void
}

export const SaleOrderImportViewContext = createContext<Context>({
  files: [],
  updateFiles: () => {},
  isUpload: false,
  updateUpload: () => {},
  isUploadError: {},
  updateUploadError: () => {},
  data: [],
  updateData: () => {},
})

export const SaleOrderImportViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [files, setFiles] = useState<File[]>([])
  const [isUpload, setIsUpload] = useState(false)
  const [isUploadError, setIsUploadError] = useState({})
  const [data, setData] = useState<any[]>([])

  const updateFiles = (files: File[]) => {
    setFiles(files)
  }

  const updateUpload = (isUpload: boolean) => {
    setIsUpload(isUpload)
  }

  const updateUploadError = (isUploadError: any) => {
    setIsUploadError(isUploadError)
  }

  const updateData = (data: any[]) => {
    setData(data)
  }

  return (
    <SaleOrderImportViewContext.Provider
      value={{
        isUpload,
        updateUpload,
        isUploadError,
        updateUploadError,
        files,
        updateFiles,
        data,
        updateData,
      }}>
      {children}
    </SaleOrderImportViewContext.Provider>
  )
}
